/**
 * [pug template]
 */
<template lang="pug">
  div
    .olst-field-radio-label
      label(:for="name", v-text="label")
    .olst-color(v-for="radio, index in options", v-show="showElement(index, radio)")
      .olst-tooltip
        .tooltip-container(v-show="isHoverImage(index)", transition="tooltip")
          .tooltip-header(v-text="getTooltipHeaderLabel(radio.range)")
          .tooltip-image-container
            img(:src="radio.imageZoomUrl")
          .tooltip-footer(v-text="radio.label")
      .radio-image(@mouseenter="setOverElementKey(index)", @mouseleave="setOverElementKey(null)")
        label.olst-label-component(:for="index + name")
          .image-radio-list-overlay(:class="{ 'out-of-stock': radio.outOfStock, 'selected': (selected === index) }")
          input(type="radio", :id="index + name", :name="name", :value="index", v-model="selected")
          img(:src="radio.imageUrl")
</template>
/**
 * [javascript application]
 */
<script>
import common from '../../../../lib/common/common.js'

export default {
  name: 'simple-choice',
  props: {
    name: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    options: {
      type: [Array, Object],
      default: { imageUrl: '#', label: '', range: '', imageZoomUrl: '#' }
    },
    defaultField: {
      type: [String, Number],
      default: null
    },
    tooltip_options: {
      type: [Array, Object],
      default: function () {
        return {}
      }
    },
    hiddenValues: {
      type: Array,
      default: () => []
    },
    disabledValues: {
      type: Array,
      default: () => []
    }
  },
  data: function () {
    return {
      selected: null,
      overElementKey: null
    }
  },
  created: function () {
    this.selected = this.defaultField
  },
  components: {},
  computed: {},
  methods: {
    /**
     * Vérifie si on est au dessus de l'élément en question pour afficher la tooltip ou non
     * @param {String} index L'index de l'image
     * @return {Boolean}
     */
    isHoverImage: function (index) {
      return this.overElementKey === index
    },
    /**
     * Assigne l'index de l'élément sur lequel notre souris est
     * @param {String} index L'index de l'image
     */
    setOverElementKey: function (index) {
      this.overElementKey = index
    },
    /**
     * Vérifie si on affiche ou non l'image
     * @param {String} elementRef La référence de l'élement
     * @param {String} element    L'élement
     * @return {Boolean}
     */
    showElement: function (elementRef, element) {
      return this.isHiddenElement(elementRef, element) === false && this.isDisabledElement(elementRef, element) === false
    },
    /**
     * Vérifie si l'élement est caché ou non
     * @param {String} elementRef La référence de l'élement
     * @param {String} element    L'élement
     * @return {Boolean}
     */
    isHiddenElement: function (elementRef, element) {
      if (typeof element.range !== 'undefined') {
        return common.arrayContain(this.hiddenValues, elementRef) || common.arrayContain(this.hiddenValues, element.range)
      } else {
        return common.arrayContain(this.hiddenValues, elementRef)
      }
    },
    /**
     * Vérifie si l'élement est désactivé ou non
     * @param {String} elementRef La référence de l'élement
     * @param {String} element    L'élement
     * @return {Boolean}
     */
    isDisabledElement: function (elementRef, element) {
      if (typeof element.range !== 'undefined') {
        return common.arrayContain(this.disabledValues, elementRef) || common.arrayContain(this.disabledValues, element.range)
      } else {
        return common.arrayContain(this.disabledValues, elementRef)
      }
    },
    /**
     * Vérifie si l'élement est désactivé ou non
     * @param {String} elementRef La référence de l'élement
     * @param {String} element    L'élement
     * @return {Boolean}
     */
    getTooltipHeaderLabel: function (range) {
      if (typeof this.tooltip_options[range] !== 'undefined') {
        return this.tooltip_options[range].label
      }
      return ''
    }
  },
  watch: {
    /**
     * Watcher sur le props "defaultField"
     * @param {String} newValue La nouvelle valeur
     * @param {String} oldValue L'ancienne valeur
     */
    defaultField: function (newValue, oldValue) {
      this.selected = newValue
    },
    /**
     * Watcher sur l'attribut "selected"
     * @param {String} newValue La nouvelle valeur
     * @param {String} oldValue L'ancienne valeur
     */
    selected: function (newValue, oldValue) {
      var element = null

      for (var index in this.options) {
        if (index === newValue) {
          element = { key: index, value: this.options[index] }
        }
      }
      if (element && (!this.showElement(element.key, element.value) || element.value.outOfStock)) {
        this.selected = oldValue
        return
      }

      var dataEmit = {}
      dataEmit[this.name] = { newValue: newValue }

      if (typeof this.options[newValue] === 'object') {
        const optionLabel = this.options[newValue].label
        const range = this.options[newValue].range
        if (typeof this.tooltip_options[range] === 'object') {
          const rangeLabel = this.tooltip_options[range].label
          this.$emit('image-label-changed', `${rangeLabel} : ${optionLabel}`)
        }
      }

      this.$emit('value-changed', dataEmit)
    },
    /**
     * Watcher sur le prop hiddenValues
     * @param {String} newValue La nouvelle valeur
     * @param {String} oldValue L'ancienne valeur
     */
    hiddenValues: function (newValue, oldValue) {
      for (var index in newValue) {
        if (newValue[index] === this.selected) {
          this.selected = ''
        }
      }
    },
    /**
     * Watcher sur le prop disabledValues
     * @param {String} newValue La nouvelle valeur
     * @param {String} oldValue L'ancienne valeur
     */
    disabledValues: function (newValue, oldValue) {
      for (var index in newValue) {
        if (newValue[index] === this.selected) {
          this.selected = ''
        }
      }
    }
  }
}
</script>
/**
 * [scss styles]
 */
<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// ImageRadioListWithTooltip.vue?6687daf6